<div class="bordered" *ngIf="selection.lessee">
  <table>
    <tbody>
      <tr>
        <td>{{selection.lessee | lesseeSummary}}</td>
        <td class="min"><a class="button" (click)="onRemoveLessee()" [title]="required ? 'Vybrat jiného pachtýře' : 'Odebrat pachtýře'"><span class="fa" [ngClass]="required ? 'fa-exchange' : 'fa-times'"></span></a></td>
      </tr>
    </tbody>
  </table>
</div>
<ng-container *ngIf="!selection.lessee">
  <div class="empty-info" *ngIf="!required">Není vybrán pachtýř (třetí smluvní strana). Výběr pachtýře proveďte pouze pokud vytváříte trojstrannou nájemní smlouvu.</div>
  <div class="clearfix">
    <div class="column-100 mt-5">
      <div class="input" *ngIf="options">
        <gmt-select [optionItems]="options" [itemPipe]="optionPipe" [data]="optionSelect" field="option" selectTitle="nezvoleno" (changed)="onOptionChanged($event.newValue)"></gmt-select>
        <a class="button ml-5" (click)="onCreateLessee()" title="Nový pachtýř"><span class="fa fa-plus"></span></a>
      </div>
    </div>
  </div>
</ng-container>
